import {Info, Trash2, ExternalLink  } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import { GetRequest } from "../../functions/ApiFunctions";
import { tableColumn } from "../constants/tableColumn";
import { OverlayTrigger,Tooltip } from "react-bootstrap";
import { DataSourceSearch } from "../../functions/HandleSearch";

const ListAlbums = () => {
  const [dataSource,setDataSource] = useState(null)
    const [Search, setSearch] = useState("");


  const fetchData = async () => {
    const res = await GetRequest("album")
    if (res){
      setDataSource(res)
    }
  }
  useEffect(()=>{
    fetchData()
  },[]) 

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      render: (_,record) => (
        <div className="action-table-data ">
          <div className="edit-delete-action justify-content-start">
            <div className={`badge bg-${record?.isDeleted ? "danger" : "success" } me-2`} style={{ cursor : "pointer"}}>
              {record?.isDeleted ? "Deleted" : "Active" }
              </div>
            

            <OverlayTrigger placement="top" overlay={
              <Tooltip id="printer-tooltip">
                <div>
                  {record?.createdAt && (<p>Created at {new Date(record?.createdAt).toLocaleDateString()}</p>) }
                  {record?.updatedAt && (<p>Last Updated on {new Date(record?.updatedAt).toLocaleDateString()}</p>) }
                  <p>Invite Link is  {record?.memberLinkActive ? "Active" : "Disabled" }</p>
                  {/* <p>Guest View is  {record?.AnounymousView ? "Active" : "Disabled" }</p> */}
                </div>
              </Tooltip>}>
              <Link className="me-2 p-2" >
                <Info className="feather-edit" style={{color :  record?.memberLinkActive  ? "green" : "red"}}/>
              </Link>
              
            </OverlayTrigger>
            
            <a
              className="confirm-text p-2"
              href={`https://app.photomagic.io/onboard/${record?.groupIdentifier}`}
              target="_blank"
              rel="noreferrer"
              // onClick={showConfirmationAlert}
            >
              <ExternalLink   className="feather-edit" style={{color :  "blue"}} />
            </a>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Album List</h4>
              <h6>Manage your Album</h6>
            </div>
          </div>

          {/* <div className="page-btn">
            <Link to={route.addproduct} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Add New Product
            </Link>
          </div> */}
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={Search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <button className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </button>
                </div>
              </div>

            </div>
            <div className="table-responsive">
              <Table columns={[...tableColumn.albums,...columns]} dataSource={DataSourceSearch(Search, ["name",], dataSource)}  />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListAlbums;